import { ApiService } from '../../shared/services/apiService.service';
import { Subscription } from 'rxjs';
import { secureStorage } from 'src/app/shared/services/encryption/secureservice';
import { SkeletonService } from 'src/app/shared/services/skeleton.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ClevertapService } from '../../shared/services/clevertap/clevertap.service';
import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
@Component({
  selector: 'app-tata-mitra-blogs',
  templateUrl: './tata-mitra-blogs.component.html',
  styleUrls: ['./tata-mitra-blogs.component.scss']
})
export class TataMitraBlogsComponent implements OnInit {
  sub: Subscription = new Subscription
  blogList: any;
  blogFirstValue: any;
  blogAllList: any[] = [];
  allBlogList: any;
  breadcrumbData: string = "tata-mitra-blogs"
  sortingType:string = 'N2O'
  breadcrumbdata: any = [];
  showBreadCrumb: boolean = false;
  typeOfBlog:any = ''
  currentPage: any = 1;
  totalItems: any = 0;
  itemsPerPage:any = 10;

  productLoaded:boolean = false
  blogListData: boolean = false;
  constructor(private apiService: ApiService,private localStorage:secureStorage,public skeletonService: SkeletonService,
    private router: Router,private toastrService: ToastrService,
    private cleverService: ClevertapService,
    @Inject(PLATFORM_ID) private platformId: Object) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      try {
        this.cleverService.onPageView("Tata Mitra Blogs");
      } catch { }
    }
    this.onTabclick('all');
    this.breadcrumb();
  }

  onTabclick(typeOfBlog: any) {
    this.blogAllList = [];
    this.productLoaded = false;
    this.totalItems = 0
    this.typeOfBlog = typeOfBlog
    this.currentPage = 1
    if (typeOfBlog === 'all') {
      let data = {
        "offset": 0,
        "limit": 10,
        "blog_status":"APPROVED"
      }
      this.sub.add(this.apiService.getBlogList(data).subscribe({
        next: (res: any) => {
          if(res.success){
            this.blogList = []
            this.blogList = res.data
            this.blogAllList = []
            this.blogFirstValue = []
            this.blogFirstValue = this.blogList[0]
            this.blogAllList = this.blogList.splice(1)
            this.totalItems = res.total_result
            this.sort(this.sortingType,'tab')
            this.productLoaded = true
          }
          else{
            this.blogList = []
            this.productLoaded = true

            this.blogAllList = []
            this.blogFirstValue = []
            this.blogListData = true;
            this.toastrService.warning(res.data.msg)

          }

        },
        error: () => {
          this.productLoaded = true
        },
        complete: () => {
          this.productLoaded = true
        }
      }))
    }else{
      let data: any = {}
      if (typeOfBlog === 'blogs') {
         data = {
          "offset": 0,
          "limit": 10,
          "type": "BLOG",
          "blog_status":"APPROVED"
        }
      }
      if (typeOfBlog === 'videos') {
         data = {
          "offset": 0,
          "limit": 10,
          "type": "VIDEOS",
          "type_of_blog": "VIDEO BASED",
          "blog_status":"APPROVED"
        }
      }
      if (typeOfBlog === 'news') {
         data = {
          "offset": 0,
          "limit": 10,
          "type": "NEWS",
          "type_of_blog": "IMAGE BASED",
          "blog_status":"APPROVED"
        }
      }

        this.sub.add(this.apiService.getBlogList(data).subscribe({
          next: (res: any) => {
            if(res.success){

            this.blogList = []
            this.blogAllList = []
            this.blogList = res.data
            this.blogAllList = this.blogList
            this.totalItems = res.total_result
            this.sort(this.sortingType,'tab')
            this.productLoaded = true;
            }
            else{
              this.blogList = []
              this.productLoaded = true

              this.blogAllList = []
              this.blogFirstValue = []
              this.blogListData = true;

              this.toastrService.warning(res.data.msg)

            }
          },
          error: () => {
            this.productLoaded = true
          },
          complete: () => {
            this.productLoaded = true
          }
        }))
    }

  }

  pageChange(page: any) {
    this.blogAllList = [];
    this.productLoaded = false;
    this.currentPage = page;
    if (this.typeOfBlog === 'all') {
      let data = {
        "offset": (page - 1) * 10,
        "limit": 10,
        "blog_status":"APPROVED"
      }
      this.sub.add(this.apiService.getBlogList(data).subscribe({
        next: (res: any) => {
          if(res.success){
          this.blogList = []
          this.blogList = res.data;
          this.productLoaded = true;
          this.blogAllList = []
          this.blogFirstValue = []
          this.blogFirstValue = this.blogList[0]
          this.blogAllList = this.blogList.splice(1)
          this.totalItems = res.total_result
          this.sort(this.sortingType,'tab')
          }
          else{
            this.blogList = []
            this.productLoaded = true

            this.blogAllList = []
            this.blogFirstValue = []
            this.blogListData = true;

            this.toastrService.warning(res.data.msg)

          }
        },
        error: () => { },
        complete: () => { }
      }))
    }else{
      let data: any = {}
      if (this.typeOfBlog === 'blogs') {
         data = {
          "offset": 0,
          "limit": 10,
          "type": "BLOG",
          "blog_status":"APPROVED"
        }
      }
      if (this.typeOfBlog === 'videos') {
         data = {
          "offset": 0,
          "limit": 10,
          "type": "VIDEOS",
          "type_of_blog": "VIDEO BASED",
          "blog_status":"APPROVED"
        }
      }
      if (this.typeOfBlog === 'news') {
         data = {
          "offset": 0,
          "limit": 10,
          "type": "NEWS",
          "type_of_blog": "IMAGE BASED",
          "blog_status":"APPROVED"
        }
      }

        this.sub.add(this.apiService.getBlogList(data).subscribe({
          next: (res: any) => {
            if(res.success){
            this.blogList = []
            this.blogAllList = []
            this.blogList = res.data
            this.blogAllList = this.blogList
            this.totalItems = res.total_result
            this.sort(this.sortingType,'tab')
            }
            else{
              this.blogList = []
              this.productLoaded = true

              this.blogAllList = []
              this.blogFirstValue = []
              this.blogListData = true;

              this.toastrService.warning(res.data.msg)

            }
          },
          error: () => { },
          complete: () => { }
        }))
    }
  }

  sort(event: any,source:any) {
    var type
    if(source == ''){
      type = event.target.value
    }
    else{
      type = event
    }
    if (type == 'N2O') {
      this.blogAllList = this.blogAllList.sort((a, b) => {
        return <any>new Date(b.created_date) - <any>new Date(a.created_date);
      });
    }
    else if(type == 'O2N'){
      this.blogAllList = this.blogAllList.sort((a, b) => {
        return <any>new Date(a.created_date) - <any>new Date(b.created_date);
      });
    }
  }

  breadcrumb(){
    localStorage.removeItem('localBreadCrumb');
    this.breadcrumbdata =[];
    var breadcrumbList1 = {
      label: 'Blogs and Stories',
      url: `/blogs-and-stories/`
    };
    this.breadcrumbdata.push(breadcrumbList1);
    this.localStorage.setItem('localBreadCrumb', JSON.stringify(this.breadcrumbdata));
    this.showBreadCrumb = true;
  }

  gotoPath(title,id){
    var title = title.replace(/\s/g, "-").replace(/\//g, "-").replace(/\+/g, "-").replace(/\./g, "-").replace(/\,/g, "-").replace(/\:/g, "-").replace(/\?/g, "-");
    var path = 'blogs-and-stories/'+ title+'/'+id;
    this.router.navigate([path]);
  }
}
